import { useQuery } from '@tanstack/react-query';
import useSessionPlQuery from '~/hooks/queries/useSessionPlQuery';
import { customFetch } from '~/utils/customFetch';
import { ErrorObjectString } from '~/utils/typescriptHelpers';

export type ManagedDomain = {
  domain: string;
  status: 'allowed' | 'blocked';
};

type ResponseData = ManagedDomain[] | ErrorObjectString;

const getDomainManagerData = async (clientId: number | undefined) => {
  if (!clientId) {
    return null;
  }
  const requestOptions = {
    headers: {
      'content-header': 'application/json',
    },
    useNodeEndpoint: true,
  };

  const response = await customFetch.get<ResponseData>(
    `/authenticated/client/${clientId}/domain-control`,
    requestOptions,
  );

  if ('error' in response.data) {
    return null;
  }

  return response.data;
};

export const getDomainManagerQueryOptions = (clientId: number | undefined) => {
  return {
    queryKey: ['useDomainManagerQuery', clientId],
    queryFn: () => getDomainManagerData(clientId ?? undefined),
    enabled: !!clientId,
  };
};

const useDomainManagerQuery = () => {
  const { data: sessionData } = useSessionPlQuery();
  return useQuery(getDomainManagerQueryOptions(Number(sessionData?.client.id)));
};

export default useDomainManagerQuery;
